require('../../modules/es.object.to-string');
require('../../modules/es.weak-map');
require('../../modules/web.dom-collections.iterator');
var path = require('../../internals/path');

module.exports = path.WeakMap;
